import React from "react";
import { PractitionerList } from "../../../client-page/client-components/practitioner-list.component";

export const BehandlerlistePage: React.FC = () => {
	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<h1 className="text-2xl font-semibold text-gray-900 mb-6">Behandlerliste</h1>
				<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
					<PractitionerList />
				</div>
			</div>
		</div>
	);
};